import React, { useState } from 'react'
import usePathMatcher from '@hooks/usePathMatcher'
import 'twin.macro'
import { Link } from 'react-router-dom'
import clsx from 'clsx'

interface Props {
  ishighlight?: boolean
}

interface SidebarMenuInfo {
  title: string
  path: string
}

const siderbarItems: SidebarMenuInfo[] = [
  {
    title: '유저관리',
    path: 'user-management',
  },
  {
    title: '공지사항 관리',
    path: 'notice-management',
  },
  {
    title: '게시판 관리',
    path: 'post-management',
  },
  {
    title: '푸시 메시지 관리',
    path: 'push-management',
  },
  {
    title: '이벤트 관리',
    path: 'event-management',
  },
]

const AdminSidebar = () => {
  const { isIncludePath } = usePathMatcher()
  return (
    <>
      <section tw="w-200">
        <div tw="flex justify-center mb-25 font-bold text-2xl">어드민 메뉴</div>
        <nav tw="gap-20 flex flex-col w-full bg-neutral-100 p-15 rounded-lg items-center">
          {siderbarItems.map(({ title, path }, idx) => (
            <Link
              key={idx}
              to={`/admin/${path}`}
              className={clsx(isIncludePath(path) && 'text-blue-500')}
            >
              {title}
            </Link>
          ))}
        </nav>
      </section>
    </>
  )
}

export default AdminSidebar
